import { environment } from "src/environments/environment";

export class AppConstants {
    // Server URL
    static readonly SERVER_URL = environment.SERVER_URL;
    // Parser URL
    static readonly PARSER_URL = environment.PARSER_URL;
    // Base URL 
    static readonly BASE_URL = "cp/"
    // Secure 
    static readonly SECURE_URL = "secure/"
    // User APIs
    static readonly SIGNUP = AppConstants.BASE_URL + "signup";
    static readonly VALIDATE_OTP = AppConstants.BASE_URL + "validateotp";
    static readonly GENERATE_AND_SEND_OTP_FOR_SIGNUP = AppConstants.BASE_URL + "generateandsendotpforsignup";
    static readonly GENERATE_AND_SEND_OTP_FOR_LOGIN = AppConstants.BASE_URL + "generateandsendotpforlogin";
    static readonly SIGNIN = AppConstants.BASE_URL + "authenticate";
    static readonly SIGNIN_WITH_OTP = AppConstants.BASE_URL + "authenticatewithotp";
    static readonly CHECK_PASSWORD = AppConstants.BASE_URL + AppConstants.SECURE_URL + "user/recheckpassword";
    static readonly CHANGE_PASSWORD = AppConstants.BASE_URL + AppConstants.SECURE_URL + "user/changepassword";
    static readonly FORGOT_PASSWORD = AppConstants.BASE_URL + "forgotpassword";
    static readonly LOGOUT = AppConstants.BASE_URL + AppConstants.SECURE_URL + "logout";
    static readonly DISCARD_INVALID_TOKENS = AppConstants.BASE_URL + "discardinvalidtokens"
    static readonly CHECK_IF_USER_EXISTS = AppConstants.BASE_URL + "checkifuserexists"
    static readonly ORGANIZATION_DETAILS = AppConstants.BASE_URL + "organizationdetails"
    static readonly ORGBASEDFORM = AppConstants.BASE_URL + "orgbasedforms"
    static readonly VALIDATE_CODE = AppConstants.BASE_URL + "validatetemppassword"
    static readonly RESET_PASSWORD = AppConstants.BASE_URL + "changepassword"
    static readonly VALIDATETOKEN = AppConstants.BASE_URL + AppConstants.SECURE_URL + "validatetoken"

    // Requirement APIs
    static readonly REQSEARCHFILTER = AppConstants.BASE_URL + "requirement/searchfilter";
    static readonly CUSTOM_FILTER = AppConstants.BASE_URL + "common/customfilterdata";
    static readonly GET_REQUIREMENT_BY_ID = AppConstants.BASE_URL + "requirement/getdetaileddto";
    static readonly REQUIREMENT_DESIGNATION_SUGGESTION = AppConstants.BASE_URL + "requirement/designationsuggestion";
    static readonly REQUIREMENT_REQCODE_SUGGESTION = AppConstants.BASE_URL + "requirement/reqcodesuggestion";
    static readonly GET_ALL_JOBS_COUNT = AppConstants.BASE_URL + "requirement/getalljobscount";
    // Candidate APIs
    static readonly GET_CANDIDATE_BY_ID = AppConstants.BASE_URL + AppConstants.SECURE_URL + "candidate/getcandidatbyidorgid";
    static readonly UPDATE_CANDIDATE = AppConstants.BASE_URL + AppConstants.SECURE_URL + "candidate/";
    static readonly DUPLICATION_CHECK_RESUMEATS = AppConstants.BASE_URL + AppConstants.SECURE_URL + "candidate/duplicationcheckforresumeATS";
    static readonly CONVERT_TO_PDF = AppConstants.BASE_URL + AppConstants.SECURE_URL + "common/converttopdf";
    static readonly PARSE_PDF = AppConstants.BASE_URL + AppConstants.SECURE_URL + "common/parsepdf";



    // Applicant APIs
    static readonly GET_ALL_APPLIED_JOBS_BY_ID = AppConstants.BASE_URL + AppConstants.SECURE_URL + "candidate/getallappliedjobs";
    static readonly CHECK_IF_JOB_ALREADY_APPLIED = AppConstants.BASE_URL + AppConstants.SECURE_URL + "applicant/checkifjobalreadyapplied";
    // Questionnaire APIs
    static readonly GET_COMPLETE_QUESTIONNAIRE_BY_ID = AppConstants.BASE_URL + AppConstants.SECURE_URL + "questionnaire/getcompletetemplatebyid";
    static readonly SUBMIT_APPLICANT_QUESTIONNAIRE_ANSWER = AppConstants.BASE_URL + AppConstants.SECURE_URL + "applicantquestionnaireanswer/saveanswerlist";
    // static readonly SUBMIT_APPLICANT_QUESTIONNAIRE_ANSWER = AppConstants.BASE_URL + AppConstants.SECURE_URL + "applicantquestionnaireanswer/saveanswerlist";

    //Onboard
    static readonly GET_ONBOARD_DATA = AppConstants.BASE_URL + AppConstants.SECURE_URL + "onboard";
    static readonly UPDATE_ONBOARD_DATA = AppConstants.BASE_URL + AppConstants.SECURE_URL + "onboard/updatecandidateindb";
    static readonly ONBOARD_GET_BY_ID = AppConstants.BASE_URL + AppConstants.SECURE_URL + "onboard/getbyid";
    static readonly ONBOARD_GET_SNAPSHOT_BY_ID = AppConstants.BASE_URL + AppConstants.SECURE_URL + "onboard/getsnapshotviewbyid";

    //update files
    static readonly ONBOARD_SAVE_COMPENSATION_FILES = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updatecompcandidatefiles';
    static readonly ONBOARDSAVEEDUCATIONEXPFILES = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updateeduexpcandidatefiles';
    static readonly ONBOARDSAVEPRELOADFORMS = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updateformscandidatefiles';
    static readonly ONBOARDSAVEIDATTACHMENTFILES = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updateidattachcandidatefiles';
    static readonly ONBOARDGETIFFILESUPLOADED = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/viewuploadedformsforcandidate';
    static readonly ONBOARDFILEDOWNLOAD = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/createtaskforbulkdownload';
    static readonly ZIPDOWNLOAD = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/getalldownloads';
    static readonly BULKDOWNLOADFROMARCHIEVE = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'candidate/downloadbulkfolderfromarchive';
    //Profile pic
    static readonly PROFILE_PIC = AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/profilepic';
    static readonly AI_PARSER = AppConstants.BASE_URL + AppConstants.SECURE_URL + "common/getparsedresultsfromai";

}